import React from "react";
import { Box, TextField, Typography, FormControl, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form";

const EmployeeDetails = () => {
  const theme = useTheme();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <form>
      <Box>
        <FormControl sx={{ minWidth: "100%" }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 2,
              mb: 1,
            }}
          >
            FirstName
          </Typography>
          <TextField
            autoFocus={true}
            required={true}
            label="FirstName"
            {...register("first_name", { required: "FirstName is required" })}
            error={!!errors.firstName}
            helperText={errors.firstName?.message as string}
            placeholder="Enter Firstname"
            fullWidth
          />
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 2,
              mb: 1,
            }}
          >
            LastName
          </Typography>
          <TextField
            autoFocus={true}
            required={true}
            label="LastName"
            {...register("last_name", { required: "LastName is required" })}
            placeholder="Enter LastName"
            fullWidth
          />
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 2,
              mb: 1,
            }}
          >
            Username
          </Typography>
          <TextField
            autoFocus={true}
            required={true}
            label="Username"
            {...register("user_matricule", { required: "User Matricule is required" })}
            placeholder="Enter Username"
            fullWidth
          />
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 2,
              mb: 1,
            }}
          >
            Password
          </Typography>
          <TextField
            autoFocus={true}
            required={true}
            label="Password"
            {...register("password", { required: "Password is required" })}
            placeholder="Enter a password"
            fullWidth
          />
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 2,
              mb: 1,
            }}
          >
            Phone Number
          </Typography>
          <TextField
            autoFocus={true}
            required={true}
            {...register("phone", { required: "Phone Number is required" })}
            label="Phone Number"
            placeholder="Enter a phone number"
            fullWidth
          />
          <Typography
            variant="h4"
            sx={{
              fontSize: "14px",
              color: theme.palette.primary.main,
              fontWeight: 800,
              mt: 2,
              mb: 1,
            }}
          >
            Company Email
          </Typography>
          <TextField
            autoFocus={true}
            required={true}
            label="Company Email"
            {...register("email", { required: "CompanyEmail is required" })}
            placeholder="Enter Company Email"
            fullWidth
          />
        </FormControl>
      </Box>
    </form>
  );
};

export default EmployeeDetails;
